import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import '/src/styles.css';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Hero = makeShortcode("Hero");
const AnnouncementBlock = makeShortcode("AnnouncementBlock");
const TextBlock = makeShortcode("TextBlock");
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Hero slots="heading, text" className="hero-gradient" mdxType="Hero" />
    <h2 {...{
      "id": "build-add-ons-for-adobe-express"
    }}>{`Build add-ons for Adobe Express`}</h2>
    <p>{`Expand the capabilities of the quick and easy create-anything app. Empower the global creative community with solutions for millions of users.`}</p>
    <div {...{
      "className": "hero-image-container"
    }}>{`
  `}<span parentName="div" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1160px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "60.3125%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/docs/static/ae3b0e1dfee5cd72433935685f40db27/5530d/Explore_Image_3.webp 320w", "/express/add-ons/docs/static/ae3b0e1dfee5cd72433935685f40db27/0c8fb/Explore_Image_3.webp 640w", "/express/add-ons/docs/static/ae3b0e1dfee5cd72433935685f40db27/9ac9d/Explore_Image_3.webp 1160w"],
            "sizes": "(max-width: 1160px) 100vw, 1160px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/docs/static/ae3b0e1dfee5cd72433935685f40db27/dd4a7/Explore_Image_3.png 320w", "/express/add-ons/docs/static/ae3b0e1dfee5cd72433935685f40db27/0f09e/Explore_Image_3.png 640w", "/express/add-ons/docs/static/ae3b0e1dfee5cd72433935685f40db27/9708d/Explore_Image_3.png 1160w"],
            "sizes": "(max-width: 1160px) 100vw, 1160px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/add-ons/docs/static/ae3b0e1dfee5cd72433935685f40db27/9708d/Explore_Image_3.png",
            "alt": "Adobe Express add-ons",
            "title": "Adobe Express add-ons",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span>
    </div>
    <br /><br />
    <AnnouncementBlock slots="heading, text, button" className="developers-live-announcement" mdxType="AnnouncementBlock" />
    <h3 {...{
      "id": "adobe-developers-live-june-24--25-2025"
    }}>{`Adobe Developers Live, June 24 & 25, 2025`}</h3>
    <p>{`Join our virtual conference to learn about Adobe Express & Creative Cloud`}</p>
    <p><a parentName="p" {...{
        "href": "https://events.ringcentral.com/events/adobe-developers-live-2025-code-connect-grow-your-business/registration?utm_source=DevDoc%20Sites&utm_campaign=DevelopersLive"
      }}>{`Register now for free`}</a></p>
    <h2 {...{
      "id": "welcome-to-adobe-express-add-ons"
    }}>{`Welcome to Adobe Express Add-ons!`}</h2>
    <p>{`Ready to build your own add-on? Check out the Developer Journey to get started, or browse the sidebar to learn more about the `}<a parentName="p" {...{
        "href": "./getting_started/code_playground.md"
      }}>{`Code Playground`}</a>{` and start tinkering with the API right away.`}</p>
    <TextBlock slots="image, heading, text, text1" width="50%" mdxType="TextBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "709px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/docs/static/d86b9732c8f45512382eb8a2b2499f92/5530d/devjourney-1-discovery.webp 320w", "/express/add-ons/docs/static/d86b9732c8f45512382eb8a2b2499f92/0c8fb/devjourney-1-discovery.webp 640w", "/express/add-ons/docs/static/d86b9732c8f45512382eb8a2b2499f92/6e19d/devjourney-1-discovery.webp 709w"],
            "sizes": "(max-width: 709px) 100vw, 709px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/docs/static/d86b9732c8f45512382eb8a2b2499f92/dd4a7/devjourney-1-discovery.png 320w", "/express/add-ons/docs/static/d86b9732c8f45512382eb8a2b2499f92/0f09e/devjourney-1-discovery.png 640w", "/express/add-ons/docs/static/d86b9732c8f45512382eb8a2b2499f92/2fc92/devjourney-1-discovery.png 709w"],
            "sizes": "(max-width: 709px) 100vw, 709px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/add-ons/docs/static/d86b9732c8f45512382eb8a2b2499f92/2fc92/devjourney-1-discovery.png",
            "alt": "Discover",
            "title": "Discover",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "discover"
    }}>{`Discover`}</h3>
    <p>{`Explore how add-ons can expand capabilities and streamline creative workflows.`}</p>
    <p><a parentName="p" {...{
        "href": "./getting_started/developer-journey.md#discover"
      }}>{`Find inspiration →`}</a></p>
    <TextBlock slots="image, heading, text, text1" width="50%" mdxType="TextBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "710px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/docs/static/99a29a9b6372f744e2403207477144fd/5530d/devjourney-2-learn.webp 320w", "/express/add-ons/docs/static/99a29a9b6372f744e2403207477144fd/0c8fb/devjourney-2-learn.webp 640w", "/express/add-ons/docs/static/99a29a9b6372f744e2403207477144fd/3267d/devjourney-2-learn.webp 710w"],
            "sizes": "(max-width: 710px) 100vw, 710px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/docs/static/99a29a9b6372f744e2403207477144fd/dd4a7/devjourney-2-learn.png 320w", "/express/add-ons/docs/static/99a29a9b6372f744e2403207477144fd/0f09e/devjourney-2-learn.png 640w", "/express/add-ons/docs/static/99a29a9b6372f744e2403207477144fd/911ab/devjourney-2-learn.png 710w"],
            "sizes": "(max-width: 710px) 100vw, 710px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/add-ons/docs/static/99a29a9b6372f744e2403207477144fd/911ab/devjourney-2-learn.png",
            "alt": "Learn",
            "title": "Learn",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "learn"
    }}>{`Learn`}</h3>
    <p>{`Familiarize and experiment with powerful features in our Code Playground.`}</p>
    <p><a parentName="p" {...{
        "href": "./getting_started/developer-journey.md#learn"
      }}>{`Dive deeper →`}</a></p>
    <TextBlock slots="image, heading, text, text1" width="50%" mdxType="TextBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "710px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/docs/static/cf8b2617e92911b6cae6d78094fc5c14/5530d/devjourney-3-develop.webp 320w", "/express/add-ons/docs/static/cf8b2617e92911b6cae6d78094fc5c14/0c8fb/devjourney-3-develop.webp 640w", "/express/add-ons/docs/static/cf8b2617e92911b6cae6d78094fc5c14/3267d/devjourney-3-develop.webp 710w"],
            "sizes": "(max-width: 710px) 100vw, 710px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/docs/static/cf8b2617e92911b6cae6d78094fc5c14/dd4a7/devjourney-3-develop.png 320w", "/express/add-ons/docs/static/cf8b2617e92911b6cae6d78094fc5c14/0f09e/devjourney-3-develop.png 640w", "/express/add-ons/docs/static/cf8b2617e92911b6cae6d78094fc5c14/911ab/devjourney-3-develop.png 710w"],
            "sizes": "(max-width: 710px) 100vw, 710px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/add-ons/docs/static/cf8b2617e92911b6cae6d78094fc5c14/911ab/devjourney-3-develop.png",
            "alt": "Develop",
            "title": "Develop",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "develop"
    }}>{`Develop`}</h3>
    <p>{`Transform your ideas into a polished product following our best practices.`}</p>
    <p><a parentName="p" {...{
        "href": "./getting_started/developer-journey.md#develop"
      }}>{`Start building →`}</a></p>
    <TextBlock slots="image, heading, text, text1" width="50%" mdxType="TextBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "709px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/docs/static/182150c16577c5ffcaaadcdd1da277fe/5530d/devjourney-4-distribute.webp 320w", "/express/add-ons/docs/static/182150c16577c5ffcaaadcdd1da277fe/0c8fb/devjourney-4-distribute.webp 640w", "/express/add-ons/docs/static/182150c16577c5ffcaaadcdd1da277fe/6e19d/devjourney-4-distribute.webp 709w"],
            "sizes": "(max-width: 709px) 100vw, 709px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/docs/static/182150c16577c5ffcaaadcdd1da277fe/dd4a7/devjourney-4-distribute.png 320w", "/express/add-ons/docs/static/182150c16577c5ffcaaadcdd1da277fe/0f09e/devjourney-4-distribute.png 640w", "/express/add-ons/docs/static/182150c16577c5ffcaaadcdd1da277fe/2fc92/devjourney-4-distribute.png 709w"],
            "sizes": "(max-width: 709px) 100vw, 709px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/add-ons/docs/static/182150c16577c5ffcaaadcdd1da277fe/2fc92/devjourney-4-distribute.png",
            "alt": "Distribute",
            "title": "Distribute",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "distribute"
    }}>{`Distribute`}</h3>
    <p>{`Share your add-on with the world in the Adobe Express Marketplace.`}</p>
    <p><a parentName="p" {...{
        "href": "./getting_started/developer-journey.md#distribute"
      }}>{`Launch now →`}</a></p>
    {/* ## Adobe Fund for Design: Bring Your Ideas to Life! */}
    <br /><br />
    <div style={{
      "display": "flex",
      "justifyContent": "center"
    }}>
  <iframe width="779" height="438" src="https://www.youtube.com/embed/CHBiTTN1neE" title="Introduction to Adobe Express Add-ons" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
    </div>
    <br /><br />
    <h2 {...{
      "id": "get-paid-to-build-add-ons"
    }}>{`Get paid to build add-ons`}</h2>
    <p>{`Have a creative idea for an Adobe Express add-on? Get `}<strong parentName="p">{`funding`}</strong>{`, resources, and support through the `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/fund-for-design"
      }}>{`Adobe Fund for Design`}</a>{`.`}</p>
    <div style={{
      "display": "flex",
      "justifyContent": "center",
      "marginBottom": "20px",
      "marginTop": "30px"
    }}>
  <iframe width="315" height="560" style={{
        "borderRadius": "10px"
      }} src="https://www.youtube.com/embed/76hGc6mlSSA" title="YouTube Shorts" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen>
  </iframe>
    </div>
    <p>{`We’re backing innovative solutions that unlock the most popular and `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/fund-for-design/#what-were-looking-for"
      }}>{`trending`}</a>{` use cases. `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/fund-for-design"
      }}>{`Apply now`}</a>{` and turn your vision into reality!`}</p>
    <h2 {...{
      "id": "get-inspiration-and-try-out-add-ons-in-the-marketplace"
    }}>{`Get inspiration and try out add-ons in the Marketplace`}</h2>
    <p>{`Do you want to try some add-ons first? Open `}<a parentName="p" {...{
        "href": "https://express.adobe.com/add-ons"
      }}>{`Adobe Express`}</a>{` and click on the `}<strong parentName="p">{`Add-ons`}</strong>{` button located in the left-hand sidebar. Browse through Adobe's picks, the Collections or use the search bar to find specific add-ons.`}</p>
    <p><a parentName="p" {...{
        "href": "https://express.adobe.com/add-ons"
      }}><span parentName="a" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1280px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "42.5%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "display": "block",
              "transition": "opacity 0.5s 0.5s",
              "pointerEvents": "none"
            }
          }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/express/add-ons/docs/static/eb5b38f1131efba6d8b1641e6e518d45/5530d/addons.webp 320w", "/express/add-ons/docs/static/eb5b38f1131efba6d8b1641e6e518d45/0c8fb/addons.webp 640w", "/express/add-ons/docs/static/eb5b38f1131efba6d8b1641e6e518d45/94b1e/addons.webp 1280w", "/express/add-ons/docs/static/eb5b38f1131efba6d8b1641e6e518d45/0b34d/addons.webp 1920w", "/express/add-ons/docs/static/eb5b38f1131efba6d8b1641e6e518d45/f3963/addons.webp 2500w"],
              "sizes": "(max-width: 1280px) 100vw, 1280px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/express/add-ons/docs/static/eb5b38f1131efba6d8b1641e6e518d45/dd4a7/addons.png 320w", "/express/add-ons/docs/static/eb5b38f1131efba6d8b1641e6e518d45/0f09e/addons.png 640w", "/express/add-ons/docs/static/eb5b38f1131efba6d8b1641e6e518d45/bbbf7/addons.png 1280w", "/express/add-ons/docs/static/eb5b38f1131efba6d8b1641e6e518d45/ac7a9/addons.png 1920w", "/express/add-ons/docs/static/eb5b38f1131efba6d8b1641e6e518d45/6482f/addons.png 2500w"],
              "sizes": "(max-width: 1280px) 100vw, 1280px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/express/add-ons/docs/static/eb5b38f1131efba6d8b1641e6e518d45/bbbf7/addons.png",
              "alt": "discover add-ons image",
              "title": "discover add-ons image",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "opacity": "0",
                "transition": "opacity 0.5s",
                "color": "inherit",
                "boxShadow": "inset 0px 0px 0px 400px none",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
    `}</span></a></p>
    <p>{`Click on an add-on to view more information and install it. That's it!`}</p>
    <h2 {...{
      "id": "whats-next"
    }}>{`What's next?`}</h2>
    <p>{`Continue by reading the `}<a parentName="p" {...{
        "href": "./getting_started/developer-journey.md"
      }}>{`Developer Journey`}</a>{` and explore the `}<a parentName="p" {...{
        "href": "./getting_started/code_playground.md"
      }}>{`Code Playground`}</a>{`!`}</p>
    <InlineAlert slots="text" mdxType="InlineAlert" />
    <p><strong parentName="p">{`Join Us: Office Hours for Adobe Express Developers`}</strong>{` `}<br /><br />{`
Receive real-time support, have your questions answered, and connect with both experts and peers for discussions on all things related to add-ons. Join us every month on Wednesdays at 8 AM PT. `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/developers-live"
      }}>{`Register for our next session here`}</a>{`.`}</p>
    <br /><br /><br /><br />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      